function removeCookieBannerInEditorMode() {
  if (window.Shopify?.designMode) {
    const observer = new MutationObserver(() => {
      const cookieBanner = document.querySelector(".cky-consent-container");
      if (cookieBanner) {
        cookieBanner.remove();
      }
    }).observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
    }, 5000);
  }
}

removeCookieBannerInEditorMode();

const refreshProductIndexes = () => {
  document
    .querySelectorAll(".chart-position")
    .forEach((chartPosition, index) => {
      console.log("chartPosition", chartPosition);
      const productId = chartPosition.dataset.productId;
      const indexLimit = chartPosition.dataset.indexLimit;

      const productIndex = window.__collectionProductIndexes.findIndex(
        (product) => product.id === Number(productId)
      );
      if (productIndex !== -1) {
        const span = document.createElement("span");
        span.textContent = productIndex + 1;
        chartPosition.innerHTML = null;
        chartPosition.appendChild(span);
        if (
          indexLimit >= parseInt(span.textContent) &&
          parseInt(span.textContent) > 0
        ) {
          chartPosition.classList.remove("hidden-position");
        }
      }
    });
};
document.addEventListener("collection:rerendered", refreshProductIndexes);
